import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import DashboardContent from 'components/DashboardContent/styles';
import DashboardHeader from 'components/DashboardHeader/styles';
import {
  FirstScreenBox,
  FirstScreenBoxContainer,
  FirstScreenButton,
  FirstScreenText,
  FirstScreenTitle,
  SelfDeliveryContainer
} from 'routes/App/byocOnboarding/FirstScreen/styles';
import FirstScreenImg from 'assets/selfDelivery/first_screen_img.svg';
import IconSave from 'assets/selfDelivery/icon_save.svg';
import IconVisibility from 'assets/selfDelivery/icon_visibility.svg';
import IconExperience from 'assets/selfDelivery/icon_experience.svg';
import IconTracking from 'assets/selfDelivery/icon_tracking.svg';
import Headline from 'components/Headline/styles';
import {ButtonPrimary} from 'components/buttons';

const FirstScreen = () => {
  const history = useHistory();
  return (
    <DashboardContent className='DashboardContent'>
      <DashboardHeader>
        <Headline className='mTop5'>Self Delivery</Headline>
      </DashboardHeader>
      <SelfDeliveryContainer>
        <img
          className='FirstScreenImg'
          src={FirstScreenImg}
          alt='Self Delivery'
        />
        <FirstScreenTitle>Increase 3rd party Orders Profit</FirstScreenTitle>
        <FirstScreenText>
          Use Sauce drivers for your 3rd party orders and increase your bottom
          line
        </FirstScreenText>
        <FirstScreenBoxContainer>
          <FirstScreenBox>
            <img src={IconSave} alt='Save' />
            <div className='title'>Save on Fees</div>
            <div className='subtitle'>
              Reduce third-party delivery commissions
            </div>
          </FirstScreenBox>
          <FirstScreenBox>
            <img src={IconVisibility} alt='Visibility' />
            <div className='title'>Improved Visibility</div>
            <div className='subtitle'>
              Watch all of your orders in one place
            </div>
          </FirstScreenBox>
          <FirstScreenBox>
            <img src={IconExperience} alt='Experience' />
            <div className='title'>Better Experience</div>
            <div className='subtitle'>
              Provide personalized customer service
            </div>
          </FirstScreenBox>
          <FirstScreenBox>
            <img src={IconTracking} alt='Tracking' />
            <div className='title'>Real-time Tracking</div>
            <div className='subtitle'>Monitor all deliveries in real-time</div>
          </FirstScreenBox>
        </FirstScreenBoxContainer>
        <FirstScreenButton>
          <ButtonPrimary
            onClick={() => history.push('/byoc-onboarding/sign-up')}
            type='button'
          >
            <span>Activate Self Delivery</span>
          </ButtonPrimary>
        </FirstScreenButton>
      </SelfDeliveryContainer>
    </DashboardContent>
  );
};

export default FirstScreen;
